export default __webpack_public_path__ + "static/assets/31033144e14c0bb0ae2eee6bf3a2ac3a.png";